import { mapBatch, type RawCat } from './batch';
import { state } from './state';
import { visitorHeaders } from './visitorId';

function visitorFetchOpts(): RequestInit {
  return {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: visitorHeaders(),
  };
}

export type FetchBatchResult = {
  batch: ReturnType<typeof mapBatch>;
  rawCount: number;
  limit: number;
};

export type CatPayload = RawCat & {
  public_id?: string;
  width?: number;
  height?: number;
  moderated_at?: number;
};

export async function fetchMoreGallery(
  limit?: number,
  filter?: string,
  offset?: number,
): Promise<FetchBatchResult> {
  const n = limit ?? 8;
  const f = filter ?? state.filter;
  const o = offset ?? state.offset;
  const r = await fetch(
    `/api/more?limit=${n}&filter=${encodeURIComponent(f)}&offset=${o}`,
    { cache: 'no-store' },
  );
  if (!r.ok) throw new Error(String(r.status));
  const raw = await r.json() as RawCat[];
  const existing = new Set(state.allCats.map(c => c.url));
  return {
    batch: mapBatch(raw, state, existing),
    rawCount: raw.length,
    limit: n,
  };
}

export async function fetchMyLikesOnly(limit?: number, offset?: number): Promise<FetchBatchResult> {
  const n = limit ?? 8;
  const o = offset ?? state.offset;
  const r = await fetch(`/api/mylikes?limit=${n}&offset=${o}`, visitorFetchOpts());
  if (!r.ok) throw new Error(String(r.status));
  const raw = await r.json() as RawCat[];
  const existing = new Set(state.allCats.map(c => c.url));
  return {
    batch: mapBatch(raw, state, existing),
    rawCount: raw.length,
    limit: n,
  };
}

export async function fetchCatByPublicId(publicId: string): Promise<CatPayload | null> {
  const r = await fetch(`/api/cat?id=${encodeURIComponent(publicId)}`, { cache: 'no-store' });
  if (r.status === 404) return null;
  if (!r.ok) throw new Error(String(r.status));
  return await r.json() as CatPayload;
}
